export const OSATYPEKEY = {
  OSA: 1,
  WEEK: 2,
};

export const PROCESSKEY = {};
